export const enhanceColumns = [
  { field: "priority", headerName: "PRIORITY", sortable: true, group: "PRIORITY INFORMATION",minWidth: 230, },
  { field: "episodeId", headerName: "EPISODE ID", sortable: true, group: "EPISODE INFORMATION" },
  { field: "mrn", headerName: "MRN", group: "EPISODE INFORMATION"},
  { field: "dob", headerName: "DATE OF BIRTH",type: "date",filterable: false, group: "EPISODE INFORMATION" },
  { field: "age", headerName: "AGE", group: "EPISODE INFORMATION",filterable: false },
  { field: "sex", headerName: "SEX", group: "EPISODE INFORMATION",filterable: false },
  { field: "admitDate", headerName: "ADMISSION DATE", group: "EPISODE INFORMATION",filterable: false },
  { field: "dischargeDate", headerName: "SEPARATION DATE", group: "EPISODE INFORMATION",filterable: false },
  { field: "speciality", headerName: "SPECIALTY", group: "EPISODE INFORMATION" },
  { field: "los", headerName: "LOS", group: "EPISODE INFORMATION",filterable: false },
  { field: "diagnosis", headerName: "PRINCIPAL DIAGNOSIS", group: "CLINICAL INFORMATION" },
  { field: "additionalDiagnosis", headerName: "ADDITIONAL DIAGNOSES", group: "CLINICAL INFORMATION",filterable: false },
  { field: "procedureDiagnosis", headerName: "PROCEDURE CODES", group: "CLINICAL INFORMATION" },

  { field: "currentDrg", headerName: "CURRENT DRG", group: "CLINICAL INFORMATION" },
  { field: "drgVersion", headerName: "DRG VERSION", group: "CLINICAL INFORMATION" },
   { field: "auditStatus", headerName: "AUDIT STATUS",group: "AUDIT INFORMATION" },
  { field: "isDrgDifferent", headerName: "IS DRG DIFFERENT",group:"DRG ANALYSIS",filterable:false },
{ field: "auditRuleCategory", headerName: "AUDIT RULE CATEGORY",group: "AUDIT INFORMATION"  },
{ field: "auditRuleRefNo", headerName: "AUDIT RULE REF NO",group: "AUDIT INFORMATION"  },
{ field: "auditShortDescription", headerName: "AUDIT SHORT DESCRIPTION",filterable: false,group: "AUDIT INFORMATION"  },
{ field: "auditLongDescription", headerName: "AUDIT LONG DESCRIPTION",filterable: false, group: "AUDIT INFORMATION"  },
{ field: "auditUserMessage", headerName: "AUDIT RULE USER MESSAGE",group: "AUDIT INFORMATION",filterable: false  },
{ field: "episodeFailedMultipleRules", headerName: "EPISODE FAILED MULTIPLE RULES",group: "AUDIT INFORMATION",filterable: false  },

// { field: "currentDrgRevenue", headerName: "CURRENT DRG REVENUE",group:"FINANCIAL INFORMATION",filterable: false },
// { field: "auditDrgRevenue", headerName: "AUDIT DRG REVENUE",group:"FINANCIAL INFORMATION",filterable: false },
{ field: "healthFund", headerName: "HEALTH FUND",group:"PATIENT/HOSPITAL INFORMATION" },
{ field: "hospitalType", headerName: "HOSPITAL TYPE",group:"PATIENT/HOSPITAL INFORMATION",filterable: false },
{ field: "careType", headerName: "CARE TYPE",group:"PATIENT/HOSPITAL INFORMATION",filterable: false },
{ field: "sourceofReferral", headerName: "SOURCE OF REFERRAL",group:"PATIENT/HOSPITAL INFORMATION",filterable: false },
{ field: "modeofSeparation", headerName: "MODE OF SEPARATION",group:"PATIENT/HOSPITAL INFORMATION",filterable: false },
{ field: "fileName", headerName: "FILE NAME",group:"ADMINISTRATIVE INFORMATION" },
{ field: "coderName", headerName: "CODER NAME",group:"ADMINISTRATIVE INFORMATION"  },
{ field: "loadID", headerName: "LOAD ID",group:"ADMINISTRATIVE INFORMATION",filterable: false  },
{ field: "createdAt", headerName: "CREATED AT",group:"ADMINISTRATIVE INFORMATION",filterable: false  },
];


// export const enhanceRows = [
//   {
//     priority: "P1",
//     episodeId: "EP-10442",
//     mrn: "MRN-92011",
//     dob: "12/05/1985",
//     age: 38,
//     sex: "M",
//     admitDate: "12/05/2023",
//     dischargeDate: "18/05/2023",
//     los: 6,
//     diagnosis: "I21.9 Acute Myocardial Infarction",
//     currentDrg: "A12B",
//     drgVersion: "v10",
//     auditStatus: "Open",
//     auditRuleCategory: "Clinical Validation",
//     auditRuleRefNo: "AR-1001",
//     auditShortDescription: "Acute MI DRG validation",
//     currentDrgRevenue: "$12,450",
//     auditDrgRevenue: "$13,200",
//     healthFund: "Bupa",
//     hospitalType: "Private",
//     careType: "Inpatient",
//     fileName: "EP10442.pdf",
//     coderName: "John Smith",
//   },
//   {
//     priority: "P2",
//     episodeId: "EP-10459",
//     mrn: "MRN-88432",
//     dob: "22/11/1954",
//     age: 69,
//     sex: "F",
//     admitDate: "14/05/2023",
//     dischargeDate: "15/05/2023",
//     los: 1,
//     diagnosis: "M16.1 Other Primary Coxarthrosis",
//     currentDrg: "O66Z",
//     drgVersion: "v10",
//     auditStatus: "Closed",
//     auditRuleCategory: "Coding",
//     auditRuleRefNo: "AR-1002",
//     auditShortDescription: "Procedure code mismatch",
//     currentDrgRevenue: "$8,900",
//     auditDrgRevenue: "$9,500",
//     healthFund: "Medibank",
//     hospitalType: "Public",
//     careType: "Day Care",
//     fileName: "EP10459.pdf",
//     coderName: "Emma Wilson",
//   },
//   {
//     priority: "P1",
//     episodeId: "EP-10462",
//     mrn: "MRN-77123",
//     dob: "05/01/1972",
//     age: 51,
//     sex: "M",
//     admitDate: "10/05/2023",
//     dischargeDate: "22/05/2023",
//     los: 12,
//     diagnosis: "G40.9 Epilepsy, Unspecified",
//     currentDrg: "N11B",
//     drgVersion: "v10",
//     auditStatus: "Pending",
//     auditRuleCategory: "Documentation",
//     auditRuleRefNo: "AR-1003",
//     auditShortDescription: "Missing physician documentation",
//     currentDrgRevenue: "$15,000",
//     auditDrgRevenue: "$16,350",
//     healthFund: "HCF",
//     hospitalType: "Private",
//     careType: "Inpatient",
//     fileName: "EP10462.pdf",
//     coderName: "David Lee",
//   },
//   {
//     priority: "P2",
//     episodeId: "EP-10488",
//     mrn: "MRN-90321",
//     dob: "18/08/1992",
//     age: 31,
//     sex: "F",
//     admitDate: "18/05/2023",
//     dischargeDate: "20/05/2023",
//     los: 2,
//     diagnosis: "C34.9 Malignant Neoplasm of Bronchus",
//     currentDrg: "R01B",
//     drgVersion: "v10",
//     auditStatus: "Open",
//     auditRuleCategory: "Clinical Validation",
//     auditRuleRefNo: "AR-1004",
//     auditShortDescription: "Review diagnosis assignment",
//     currentDrgRevenue: "$10,800",
//     auditDrgRevenue: "$11,950",
//     healthFund: "NIB",
//     hospitalType: "Private",
//     careType: "Inpatient",
//     fileName: "EP10488.pdf",
//     coderName: "Sophia Brown",
//   },
//   {
//     priority: "P1",
//     episodeId: "EP-10512",
//     mrn: "MRN-66234",
//     dob: "19/09/1945",
//     age: 78,
//     sex: "M",
//     admitDate: "19/05/2023",
//     dischargeDate: "25/05/2023",
//     los: 6,
//     diagnosis: "J44.9 Chronic Obstructive Pulmonary Disease",
//     currentDrg: "M44C",
//     drgVersion: "v10",
//     auditStatus: "Closed",
//     auditRuleCategory: "Revenue",
//     auditRuleRefNo: "AR-1005",
//     auditShortDescription: "Revenue adjustment completed",
//     currentDrgRevenue: "$9,750",
//     auditDrgRevenue: "$10,600",
//     healthFund: "AHM",
//     hospitalType: "Public",
//     careType: "Inpatient",
//     fileName: "EP10512.pdf",
//     coderName: "Michael Scott",
//   },
// ];